module.exports = __webpack_public_path__ + "img/product2.123e7b2a.png";